import _shuffle from 'lodash/shuffle'
import { arrayIterator } from 'utils/array-iterator'

//TODO: test completed but throwing error

export const getRandomUniqueNumbers = (min: number, max: number, howMany: number) => {
  return _shuffle(arrayIterator(max - min, min)).slice(0, howMany)
}
